import request from '@/utils/request'
//学校界面根据teg获取内容
export function GetSchoolTeg(data) {
  return request({
    url: '/html/school/teg',
    method: 'get',
    params: data
  })
}
//学校界面根据teg获取内容
export function GetSchool(data) {
  return request({
    url: 'html/getHuatiSchool',
    method: 'get',
    params: data
  })
}


// WEBPACK FOOTER //
// ./src/api/school.js